import {
  MinimalButton,
  ScrollMode,
  SpecialZoomLevel,
  Viewer,
  ViewMode,
  Worker,
} from '@react-pdf-viewer/core'
import {NextIcon, pageNavigationPlugin, PreviousIcon} from '@react-pdf-viewer/page-navigation'
import {ThumbnailDirection, thumbnailPlugin} from '@react-pdf-viewer/thumbnail'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/page-navigation/lib/styles/index.css'
import '@react-pdf-viewer/thumbnail/lib/styles/index.css'
import {useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {getSinglePitchDeck} from '../core/_request'
import {useInvestorDatabase} from '../../investor-database/core/InvestorContext'
import {GET_FILE_URL} from '../../onboarding/core/_requests'

export const PdfPreview = () => {
  const pageNavigationPluginInstance = pageNavigationPlugin()
  const {jumpToNextPage, jumpToPreviousPage} = pageNavigationPluginInstance
  const [fileName, setfileName] = useState('')
  const thumbnailPluginInstance = thumbnailPlugin()
  const {Thumbnails} = thumbnailPluginInstance
  const {pitchDeckId} = useParams()
  const {setStoreFileName} = useInvestorDatabase()

  const SinglePitchDeck = async (pitchDeckId: any) => {
    try {
      const {
        data: {data, success},
      } = await getSinglePitchDeck(pitchDeckId)
      if (success) {
        setfileName(data?.file?.name)
        setStoreFileName(data?.file?.name)
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    SinglePitchDeck(pitchDeckId)
  }, [pitchDeckId]) //eslint-disable-line

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.key === 'ArrowRight') {
        jumpToNextPage()
      } else if (e.key === 'ArrowLeft') {
        jumpToPreviousPage()
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [jumpToNextPage, jumpToPreviousPage])

  return (
    <>
      {fileName && (
        <>
          {fileName.split('.').pop() === 'pdf' ? (
            <div
              style={{
                border: 'none',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                borderRadius: '4px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
              className='my-5 mx-6'
            >
              <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js'>
                <div
                  style={{
                    borderBottom: '1px solid rgba(0, 0, 0, .3)',
                    height: '40rem',
                    position: 'relative',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '1rem',
                      transform: 'translate(0, -100%) rotate(-90deg)',
                      zIndex: '1',
                    }}
                  >
                    <MinimalButton onClick={jumpToPreviousPage}>
                      <PreviousIcon />
                    </MinimalButton>
                  </div>
                  {fileName && (
                    <Viewer
                      defaultScale={SpecialZoomLevel.PageFit}
                      scrollMode={ScrollMode.Page}
                      viewMode={ViewMode.SinglePage}
                      fileUrl={`${process.env.REACT_APP_BASE_API_URL}/file/${encodeURIComponent(
                        fileName || ''
                      )}`}
                      plugins={[pageNavigationPluginInstance, thumbnailPluginInstance]}
                    />
                  )}

                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '1rem',
                      transform: 'translate(0, -100%) rotate(-90deg)',
                      zIndex: '1',
                    }}
                  >
                    <MinimalButton onClick={jumpToNextPage}>
                      <NextIcon />
                    </MinimalButton>
                  </div>
                </div>
                <div
                  style={{
                    height: '12rem',
                    overflow: 'auto',
                  }}
                >
                  <Thumbnails thumbnailDirection={ThumbnailDirection.Horizontal} />
                </div>
              </Worker>
            </div>
          ) : (
            <div className='iframe-container my-5 mx-6'>
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${GET_FILE_URL}/${encodeURIComponent(
                  fileName || ''
                )}`}
                width='100%'
                height='560px'
                title='Embedded PPTX file'
              ></iframe>
            </div>
          )}
        </>
      )}
    </>
  )
}
